/**
 * Created by intellicar-rinas on 4/10/17.
 */
import {
  schemaTypes,
  dateFormat,
} from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
import _ from "lodash";
import actions from '../../../store/actions';

export const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  let rows = Array.isArray(respObj) ? respObj : [];

  const parseAddrs = (addrs) => {
    if (!addrs) return [null, null];
    let m = String(addrs).match(/\(?\s*([-\d.]+)\s*,\s*([-\d.]+)\s*\)?/);
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : [null, null];
  };

  for (let idx in rows) {
    let eachitem = rows[idx];
    let StartLatLng = parseAddrs(eachitem.startaddrs);
    let EndLatLng = parseAddrs(eachitem.endaddrs);
    historyData.push({
      vehicleid: eachitem.vehicleid,
      vehicleno: eachitem.vehicleno,
      deviceno: eachitem.deviceno,
      starttime:
        eachitem.starttime != null
          ? moment(eachitem.starttime).format(dateFormat)
          : null,
      endtime:
        eachitem.endtime != null
          ? moment(eachitem.endtime).format(dateFormat)
          : null,
      startsoc: eachitem.startsoc != null ? eachitem.startsoc : null,
      endsoc: eachitem.endsoc != null ? eachitem.endsoc : null,
      distance:
        eachitem.distance != null
          ? parseFloat(Number(eachitem.distance).toFixed(2))
          : null,
      averagespeed:
        eachitem.averagespeed != null
          ? parseFloat(Number(eachitem.averagespeed).toFixed(2))
          : null,
      maxspeed:
        eachitem.maxspeed != null
          ? parseFloat(Number(eachitem.maxspeed).toFixed(2))
          : null,
      maxcurrent:
        eachitem.maxcurrent != null
          ? parseFloat(Number(eachitem.maxcurrent).toFixed(2))
          : null,
      startloc: eachitem.startaddrs || null,
      endloc: eachitem.endaddrs || null,
      StartLatLng,
      EndLatLng,
    });
  }

  callback(historyData);
};

const getHistory = (schema, data, store) => {
  // mixpanel.track("User Looks For Daily Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });

  window.resetIndex()
  if (window.setReportWindowTabBusy)
    window.setReportWindowTabBusy(schema, true);
  window.getButtonClicked = true;
  schema.showPage = true
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  window.graphDataErr = "";
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  let vehicleDataForReport = {}
  let fixedQueryLimit = 700;
  let splitedVehicles = []
  let vehicleids = []
  data.vehicle = window.selectedItems && window.selectedItems.length ? window.selectedItems : window.itemClicked ? window.selectedVehicles : window.selectedVehicles && window.selectedVehicles.length ? window.selectedVehicles : []
  // data.vehicle =  window.selectedVehicles ? window.selectedVehicles : []
  if(!data.vehicle.length){
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if(endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 35 days",
        content: "You can't select date range of more than 35 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if(starttime >= endtime){
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  // if(starttime === endtime){
  //   endtime = endtime + (1000 * 60 * 60 * 24 - 60000)
  // }
  // let tempEndtime = endtime
  // let value=moment(tempEndtime).startOf('day')
  // tempEndtime = (value).unix() * 1000;
  // let a = (1000 * 60 * 60 * 24) - 60000
  // let diff = endtime - tempEndtime
  // if(diff === a ){
  //   endtime = endtime + 60000
  // }
  let days = (endtime - starttime)
  schema.count = 0
  days =Math.ceil( days / 86400000) //total days
  let queryLimit = data.vehicle.length * days// total query limit
  schema.count = Math.ceil(queryLimit / fixedQueryLimit) // page number
  schema.splitCount = parseInt(data.vehicle.length / schema.count) // total vehicle / total pages
  if(schema.splitCount > 50) schema.splitCount = 50

  let getReportBody = {
    starttime: starttime,
    endtime: endtime,
  }
  if( !window.selectAllClicked){ 
    // if(data.vehicle.length <=50){
      getReportBody.vehicle = data.vehicle.map((item) => {
      return item.data.vehicleid;
      })
  }
  ReportAPIs.getReportVehicles(getReportBody).then ((resp) => {
    vehicleids = resp
    let startIndex = 0
    let endIndex = schema.splitCount;
    for(let pages = 0 ; pages < schema.count; pages++){
      let page = []
      for(let idx in vehicleids){
        if(idx >= startIndex && idx <= vehicleids.length ){
          if(idx <= endIndex - 1)page.push(vehicleids[idx])
        }
      }
      splitedVehicles.push(page)
      startIndex = endIndex;
      endIndex = startIndex + schema.splitCount
      if(pages === (schema.count - 1) && startIndex <= vehicleids.length){
        if((vehicleids.length - startIndex) > 0){
          schema.count++
        }
      }
    }
    if (data.vehicle && data.vehicle.length) {
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, true);
      const handleSuccess = (resp) => {
        window.dataForAll = resp;
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        processData(resp, store.vehicleMap, (data) => {
          schema.finalData = data;
          vehicleDataForReport =  {
            endtime : endtime,
            starttime : starttime,
            exideBatteryVehicles : splitedVehicles,
            reportName : schema.key,
            exideBatteryFirstData: data,
            selectedVehicles : data.vehicle,
            exideBatteryPageno: schema.count,
            showPage: schema.showPage,
            selectedDailyVehicles : data.vehicle
          }
          store.dispatch({
            type: actions.SELECTED_VEHICLE_ID,
            data: vehicleDataForReport
          });
          if (tableStateData && tableStateData[0]) {
            tableStateData[0].body = data;
            tableStateData[0].busy = false;
            saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
          }
          if (schema.content[0].ref) {
            schema.content[0].ref.setData(data);
          }
        });
      };
      if (schema.content[0].ref) {
        schema.content[0].ref.setBusy(true);
        saveState = schema.content[0].ref.props.saveState;
        tableStateData = [
          schema.content[0].ref.state,
          schema.content[0].ref.props.schemaKey,
          schema.content[0].ref.props.data,
        ];
      }
      let auth = window.getAuth();
      let body = {
        vehicleid : splitedVehicles[0],
        token: auth.token,
        starttime: starttime,
        endtime: endtime,
      };
      ReportAPIs.getExideBatteryDailyReport(body).then(handleSuccess, (r) => {
        handleSuccess([]);
      });
    } else {

      window.dataForAll = null;
      window.graphDataErr = "Please Select Vehicle";

      if (window.InMapForceUpdate) {
        window.InMapForceUpdate();
      }
      if (window.InGraphControlForceUpdate) {
        window.InGraphControlForceUpdate();
      }
      // window.dispatchStoreEvent({
      //   type: actions.GRAPHSET_STATE_CHANGED,
      //   data: 0,
      // });
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      return;
    }
  }).catch (() => {
    console.log("failed")
    if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Data Fetching Failed",
        content: "Data fetching failed",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
  }) 
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const download = (schema, data, store) => {
  let filterdData = schema.content[0].ref.state.body;
  if (!filterdData.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "No data Available",
        content: "No data Available",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }
  schema.finalData = filterdData;
  if (schema.finalData) {
    let finalData = _.map(schema.finalData, (r) => {
      r = Object.assign({}, r);
      return r;
    });
    let heads = schema.content[0].head;
    let newData = [];
    for (let idx in finalData) {
      let tempdata = {};
      for (let rdx in heads) {
        if (heads[rdx].key in finalData[idx]) {
          tempdata[heads[rdx].name] = finalData[idx][heads[rdx].key];
        }
      }
      newData.push(tempdata);
    }
    setTimeout(() => {
      JSONToCSVConvertor(newData, "NewDailyReport", false);
    }, 500);
  }
};

const schema = {
  key: "exide_battery_report",
  name: "New Daily Report",
  showPage:false,
  finalData:null,
  count:null,
  splitCount:null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      maxCount : 6000,
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
      hideTime: true,
      schemaKey: "exide_battery_report",
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: Date.now() - 1000 * 60,
      hideTime: true,
      schemaKey: "exide_battery_report",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get New Daily Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page"
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "Vehicle No" },
        { key: "deviceno", name: "Device No" },
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        {
          key: "endtime",
          name: "End Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        { key: "startsoc", name: "Start SOC" },
        { key: "endsoc", name: "End SOC" },
        { key: "distance", name: "Distance (km)" },
        { key: "averagespeed", name: "Avg Speed (kmph)" },
        { key: "maxspeed", name: "Max Speed (kmph)" },
        { key: "maxcurrent", name: "Max Current" },
        {
          key: "startloc",
          name: "Start Location",
          width: 2,
          onClick: (d, item) => {
            if (item.StartLatLng && item.StartLatLng[0] != null) {
              window.showInGoogleMaps(item.StartLatLng[0], item.StartLatLng[1]);
            }
          },
        },
        {
          key: "endloc",
          name: "End Location",
          width: 2,
          onClick: (d, item) => {
            if (item.EndLatLng && item.EndLatLng[0] != null) {
              window.showInGoogleMaps(item.EndLatLng[0], item.EndLatLng[1]);
            }
          },
        },
      ],
    },
  ],
};
export default schema;